import './input.css';

function Input({ placeholder, inputType, inputId, inputName, inputValue, onChange, width= '250px', height= '50px', color='black', borderColor= 'white', fontSize= '1.2rem', maxLength }) {
    const style = {
        fontSize: fontSize,
        borderColor: borderColor,
        color: color,
        width: width,
        height: height,
    }

    return (
        <input 
            style={style}
            className='inputComponent'
            type={inputType} 
            id={inputId} 
            name={inputName} 
            value={inputValue} 
            onChange={onChange}
            placeholder={placeholder}
            maxLength={maxLength}
        />
    );
}

export default Input;